import { createContext } from "react";
import SocialData from "../data/socialData";

const SocialContext = createContext(SocialData);

export default SocialContext;
